import React, { ComponentProps } from 'react';
import {
  Autocomplete,
  createFilterOptions,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { CustomIcon } from 'components/CustomIcon';
import * as Styled from './MBAutocomplete.styles';
import { DefaultOptionItem } from './MBAutocomplete.types';
import MBTextField from '../MBTextField/MBTextField';

const defaultFilterOptions = createFilterOptions<DefaultOptionItem>({
  matchFrom: 'any',
  stringify: (option) => option.label,
});

const tickIcon = <CustomIcon name="tick" dense />;

const defaultRenderOption: ComponentProps<
  typeof Styled.MBAutocomplete
>['renderOption'] = (optionProps, option: DefaultOptionItem, optionState) => (
  <MenuItem {...optionProps} itemType="li" value={option.value}>
    <ListItemIcon>{optionState.selected && tickIcon}</ListItemIcon>
    <ListItemText>{option.label}</ListItemText>
  </MenuItem>
);

const MBAutocomplete: React.FC<
  Omit<ComponentProps<typeof Autocomplete>, 'renderInput'> & {
    variant: ComponentProps<typeof MBTextField>['variant'];
    renderInput?: ComponentProps<typeof Autocomplete>['renderInput'];
    error?: boolean;
    helperText?: string;
    required?: boolean;
  }
> = (props) => {
  return (
    <Styled.MBAutocomplete
      disablePortal={false}
      {...props}
      renderInput={(params) => (
        <MBTextField
          {...params}
          // @ts-expect-error // TODO: fix types
          label={props.placeholder}
          variant={props.variant}
          fullWidth={props.fullWidth}
          error={props.error}
          helperText={props.helperText}
          required={props.required}
        />
      )}
      filterOptions={props.filterOptions || defaultFilterOptions}
      clearIcon={null}
      popupIcon={
        // @ts-expect-error // TODO: fix types
        <Styled.Icon name="down" onClick={props.onClick} dense size={0.8} />
      }
      renderOption={props.renderOption || defaultRenderOption}
    />
  );
};

export default MBAutocomplete;
